import React from 'react';
import { getExtraField } from 'gatsby-core-theme/src/helpers/getters';
import useTranslate from '~hooks/useTranslate/useTranslate';
import styles from './variables.module.scss';

const Variables = ({ relation }) => {
  const winRate = getExtraField(relation.extra_fields, 'win_rate') || '-';
  const payoutSpeed = relation?.payout_time;
  return (
    <div className={styles.variables}>
      <div>
        <p>{useTranslate("payout_time", "Payout Speed")}:</p>
        <span>{payoutSpeed}</span>
      </div>

      <div>
        <p>{useTranslate("win_rate","Win Rate")}:</p>
        <span>{`${winRate}${winRate !== '-' ? '%' : ''}`}</span>
      </div>
    </div>
  );
};

export default Variables;
